import React from "react";
import { useT } from "@/lib/LanguageContext";
import { fmtCount } from "../format";
import CrmAlertDialog from "../ui/CrmAlertDialog";
import { CRM } from "../../../constants/testIds/crm";

/**
 * "Send broadcast?" (spec Screen 6, worked example: "64 → 61"): restates the audience and
 * the sendable count, plus how many of them were skipped as unsubscribed since the
 * audience was computed. Confirm posts `sendBroadcast`; Cancel posts nothing.
 */
export default function BroadcastConfirmDialog({ open, onOpenChange, viewName, preview, busy, onConfirm }) {
  const t = useT("crm");
  return (
    <CrmAlertDialog
      open={open}
      onOpenChange={onOpenChange}
      testId={CRM.broadcastConfirm}
      title={t("broadcast.confirmTitle")}
      confirmLabel={t("broadcast.send")}
      cancelLabel={t("common.cancel")}
      busy={busy}
      onConfirm={onConfirm}
      confirmTestId={CRM.broadcastConfirmSend}
      cancelTestId={CRM.broadcastConfirmCancel}
    >
      <p>{viewName ? t("broadcast.confirmAudience", { name: viewName }) : t("broadcast.confirmAudienceFilter")}</p>
      <p className="mt-2 rounded-lg bg-eh-ochre/20 px-3 py-2" data-testid={CRM.broadcastConfirmCount}>
        {t("broadcast.confirmCount", { n: fmtCount(preview?.sendable) })}
      </p>
      {!!preview?.skipped_unsubscribed && (
        <p className="mt-1 text-xs text-eh-muted">{t("broadcast.confirmSkipped", { n: fmtCount(preview.skipped_unsubscribed) })}</p>
      )}
    </CrmAlertDialog>
  );
}
